module.exports = __webpack_public_path__ + "static/media/actors-mobile.17a9711f.png";